import React, { useState, useEffect } from "react";
import NavBar from "./NavBar";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, useParams, Link } from "react-router-dom";
import { db } from "../FirebaseConfig/firebase";
import { collection, getDocs } from "firebase/firestore";
import "../CSS/registrarParticipantePaulet.css";
import { addDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import IncrementadorNum from "./IncrementadorNum";
import ItemSalon from "./ItemSalon";

const MySwal = withReactContent(Swal);

function AgregarEscenario() {
  const { idEvento } = useParams();

  const navigate = useNavigate();
  const [maxAsientos, setMaxAsientos] = React.useState("8");
  const [derVisible, setDerVisible] = useState(false); // MOSTRAR Boton de continuar
  const [mesas, setMesas] = useState([]);
  const [mesasTemporal, setMesasTemporal] = useState([]);
  //MESAS
  const getMesas = async () => {
    const mesasList = collection(db, `DistribucionSalon/`);
    const data = await getDocs(mesasList);
    const mesasObtenidas = data.docs.map((doc) => ({
      ...doc.data(),
      idFirestore: doc.id,
    }));
    setMesas(mesasObtenidas);
    setMesasTemporal(mesasObtenidas);
  };
  const agregarMesa = () => {
    const nuevaMesa = {
      id: mesas.length + 1,
      x: 0,
      y: 0,
      aLibres: maxAsientos,
      aOcupados: 0,
    };
    setMesas([...mesas, nuevaMesa]);
  };

  const eliminarMesa = (id) => {
    const nuevasMesas = mesas.filter((mesa) => mesa.id !== id);
    setMesas(nuevasMesas);
  };
  const guardarSalon = async () => {
    MySwal.fire({
      title: "¿Guardar salón? ",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Guardar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const collectionRef = collection(
          db,
          `EVENTOS/${idEvento}/DistribucionSalon`
        );

        mesas.forEach(async (objeto) => {
          await addDoc(collectionRef, objeto).then(async (docRef) => {
            console.log(idEvento);
          });
        });
        MySwal.fire("", "SALÓN GUARDADO", "success");
        navigate("../panelCDA/eventos");
      }
    });
  };
  const cerrar = () => {
    navigate("../panelCDA/eventos");
  };
  useEffect(() => {
    getMesas();
  }, []);
  return (
    <div className="eventos">
      <NavBar
        titulo="Editar Mesas | Salon de eventos"
        imagen="cerrar"
        logoTitulo="eventos"
        cerrar={cerrar}
      ></NavBar>
      <div className="registrar-grid-container">
        <div className="padre-izquierda">
          <div className="hijo-izquierda">
            <div className="formNumber">
              <label className="label" style={{ marginRight: "40px" }}>
                Asientos por mesa
              </label>
              <IncrementadorNum
                style={{ margin: "30px" }}
                contador={maxAsientos}
                setContador={setMaxAsientos}
              ></IncrementadorNum>
            </div>
            <div className="btnInferior">
              <input
                type="submit"
                value={"Agregar Mesa"}
                className="btnAbajoContinuar"
                onClick={agregarMesa}
              />
            </div>
            <div className="contenido-inferior">
              <div className="btnInferior">
                <input
                  type="submit"
                  value={"Guardar Salón"}
                  style={{
                    cursor: mesas.length > 0 ? "default" : "not-allowed",
                    opacity: mesas.length > 0 ? "1" : "0.65",
                  }}
                  className="btnAbajoContinuar"
                  onClick={guardarSalon}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="padre-derecha">
          <div className="hijo-derecha">
            <div>
              <ItemSalon
                mesas={mesas}
                eliminarMesa={eliminarMesa}
                setMesas={setMesas}
                esReserva={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgregarEscenario;
